import { render, staticRenderFns } from "./UserdataEdition.vue?vue&type=template&id=1e0c7da0"
import script from "./UserdataEdition.vue?vue&type=script&lang=ts"
export * from "./UserdataEdition.vue?vue&type=script&lang=ts"
import style0 from "./UserdataEdition.vue?vue&type=style&index=0&id=1e0c7da0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QAvatar,QForm,QInput,QIcon,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QAvatar,QForm,QInput,QIcon,QBtn})
